export const DientesEnum = Object.freeze({
    OD11: {diente:'11',idDiente:1, orden: 8},
    OD12: {diente:'12',idDiente:2, orden: 7},
    OD13: {diente:'13',idDiente:3, orden: 6},
    OD14: {diente:'14',idDiente:4, orden: 5},
    OD15: {diente:'15',idDiente:5, orden: 4},
    OD16: {diente:'16',idDiente:6, orden: 3},
    OD17: {diente:'17',idDiente:7, orden: 2},
    OD18: {diente:'18',idDiente:8, orden: 1},

    OD21: {diente:'21',idDiente:9, orden:9},
    OD22: {diente:'22',idDiente:10, orden:10},
    OD23: {diente:'23',idDiente:11, orden:11},
    OD24: {diente:'24',idDiente:12, orden:12},
    OD25: {diente:'25',idDiente:13, orden:13},
    OD26: {diente:'26',idDiente:14, orden:14},
    OD27: {diente:'27',idDiente:15, orden:15},
    OD28: {diente:'28',idDiente:16, orden:16},

    OD31: {diente:'31',idDiente:17, orden:24},
    OD32: {diente:'32',idDiente:18, orden:23},
    OD33: {diente:'33',idDiente:19, orden:22},
    OD34: {diente:'34',idDiente:20, orden:21},
    OD35: {diente:'35',idDiente:21, orden:20},
    OD36: {diente:'36',idDiente:22, orden:19},
    OD37: {diente:'37',idDiente:23, orden:18},
    OD38: {diente:'38',idDiente:24, orden:17},

    OD41: {diente:'41',idDiente:25, orden:25},
    OD42: {diente:'42',idDiente:26, orden:26},
    OD43: {diente:'43',idDiente:27, orden:27},
    OD44: {diente:'44',idDiente:28, orden:28},
    OD45: {diente:'45',idDiente:29, orden:29},
    OD46: {diente:'46',idDiente:30, orden:30},
    OD47: {diente:'47',idDiente:31, orden:31},
    OD48: {diente:'48',idDiente:32, orden:32},

    BOCACOMPLETA: {diente: 'Boca completa', idDiente: 59, orden: 33, idTipoAgrupacion: 3},

    CUADRANTE1: {diente: 'Cuadrante 1', idDiente: 66, orden: 46},
    CUADRANTE2: {diente: 'Cuadrante 2', idDiente: 69, orden: 47},
    CUADRANTE3: {diente: 'Cuadrante 3', idDiente: 70, orden: 48},
    CUADRANTE4: {diente: 'Cuadrante 4', idDiente: 71, orden: 49},

    MAXILARSUPERIOR: {diente: 'Maxilar Superior', idDiente: 57, orden: 37},
    MAXILARINFERIOR: {diente: 'Maxilar Inferior', idDiente: 58, orden: 42},

    SUPERNUMERARIO: {diente: 'Super númerario', idDiente: 137, orden: 50},

    DIENTESCUADRANTE1: {idsDientes: [1,2,3,4,5,6,7,8]},
    DIENTESCUADRANTE2: {idsDientes: [9,10,11,12,13,14,15,16]},
    DIENTESCUADRANTE3: {idsDientes: [17,18,19,20,21,22,23,24]},
    DIENTESCUADRANTE4: {idsDientes: [25,26,27,28,29,30,31,32]},

    DIENTESMAXILARSUPERIOR: {idsDientes: [1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16]},
    DIENTESMAXILARINFERIOR: {idsDientes: [17,18,19,20,21,22,23,24,25,26,27,28,29,30,31,32]},

    DIENTESBOCACOMPLETA: {idsDientes: [1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28,29,30,31,32]},

    CUADRANTE: {idTipoAgrupacion: 1},
    ARCADA: {idTipoAgrupacion: 2},

});
